import { NumberMaskProcessing } from './number';

export class CurrencyMaskProcessing extends NumberMaskProcessing {
  protected fixedDecimals = 0;
  protected min = 0;
  protected prefix = '$';
}
